export default __webpack_public_path__ + "static/logo-white-4af42f1889bc4b2c71b1b56512343af6.svg";